<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <v-select
      :items="availableBusinessProcesses"
      :label="label"
      :menu-props="{ contentClass: 'custom-scrollbar' }"
      :item-text="itemText"
      :item-value="itemValue"
      :value="value"
      @change="onValueChange"
    >
      <template v-slot:item="{ item, on, attrs }">
        <slot name="bp-list-item" :item="item" :on="on" :attrs="attrs"></slot>
      </template>
    </v-select>
  </div>
</template>

<script>
import EcsBusinessProcessSelectionMixin from '@/components/ecs-business-process-selection/EcsBusinessProcessSelectionMixin';
export default {
  name: 'EcsBusinessProcessSingleSelection',
  mixins: [EcsBusinessProcessSelectionMixin],
  watch: {
    availableBusinessProcesses(newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length !== 0) {
        this.onValueChange(newValue[0][this.itemValue]);
      }
    }
  },
  created() {
    if (this.availableBusinessProcesses.length > 0) {
      this.onValueChange(this.availableBusinessProcesses[0][this.itemValue]);
    }
  }
};
</script>
<style></style>
